import React from 'react';

// third party
import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import { styled } from '@mui/material/styles';

// project imports
import { useSelector } from 'store';

// assets
import { IconCircleCheck, IconSquareRoundedX, IconInfoCircle, IconAlertTriangle } from '@tabler/icons-react';

// Styled snackbar content - base styles only, theme colors handled by CSS
// See styles/notistack.css for theme-aware styling
const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme }) => ({
  // Base styles for all variants - colors are handled by notistack.css
  '&.notistack-MuiContent-success, &.notistack-MuiContent-error, &.notistack-MuiContent-warning, &.notistack-MuiContent-info, &.notistack-MuiContent-default': {
    borderRadius: '12px',
    border: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    fontFamily: '"Satoshi", -apple-system, BlinkMacSystemFont, sans-serif',
    padding: '14px 18px',
    minWidth: '280px',
    '& .MuiSnackbarContent-message': {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: 0,
    },
    '& svg': {
      flexShrink: 0,
      width: '20px',
      height: '20px',
    },
  },
}));

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

export default function Notistack({ children }: any) {
  const snackbar = useSelector((state) => state.snackbar);

  const successIconStyle: React.CSSProperties = {
    marginRight: 10,
    color: '#22c55e',
    flexShrink: 0,
  };

  const errorIconStyle: React.CSSProperties = {
    marginRight: 10,
    color: '#ef4444',
    flexShrink: 0,
  };

  const warningIconStyle: React.CSSProperties = {
    marginRight: 10,
    color: '#f59e0b',
    flexShrink: 0,
  };

  const infoIconStyle: React.CSSProperties = {
    marginRight: 10,
    color: '#3b82f6',
    flexShrink: 0,
  };

  return (
    <SnackbarProvider
      maxSnack={snackbar.maxStack}
      dense={snackbar.dense}
      autoHideDuration={5000}
      preventDuplicate
      iconVariant={
        snackbar.iconVariant === 'useemojis'
          ? {
              success: <IconCircleCheck size={20} style={successIconStyle} />,
              error: <IconSquareRoundedX size={20} style={errorIconStyle} />,
              warning: <IconAlertTriangle size={20} style={warningIconStyle} />,
              info: <IconInfoCircle size={20} style={infoIconStyle} />
            }
          : undefined
      }
      hideIconVariant={snackbar.iconVariant === 'hide' ? true : false}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        default: StyledMaterialDesignContent,
      }}
    >
      {children}
    </SnackbarProvider>
  );
}
